import { createLogic } from 'redux-logic'
import { map, catchError } from 'rxjs/operators'
import { throwError } from 'rxjs'
import * as constants from '../constants'

export const deleteProject = createLogic({
  type: constants.DELETE_PROJECT.ACTION,
  processOptions: {
    dispatchReturn: false
  },
  process({ http, action }, dispatch, done) {
    const { isDeleted, selectedProjectId } = action.payload

    return http.put(`/comps/project/${selectedProjectId}`, { isDeleted })
      .pipe(
        map(http.getBody),
        map(({ status }) => {
          dispatch({
            type: constants.DELETE_PROJECT.FULFILLED,
            payload: {
              ...action.payload,
              status: status.includes('failed') ? 'Project deletion failed!' : 'Project deleted successfully !'
            }
          })
        }),
        catchError(err => throwError(err))
      )
      .subscribe(
        () => {
          dispatch({
            type: constants.GET_RECENT_PROJECTS.ACTION
          })
          dispatch({
            type: constants.GET_ALL_PROJECTS.ACTION
          })
          dispatch({
            type: constants.LOAD_REGIONS.ACTION
          })
          done()
        },
        err => {
          dispatch({
            type: constants.DELETE_PROJECT.REJECTED,
            payload: err
          })
          done()
        }
      )
  }
})
